import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { QuotingToolRoutingModule } from "./quoting-tool-routing.module";
import { CreateProjectComponent } from "./create-project/create-project.component";
import { StepperFormsComponent } from "./stepper-forms/stepper-forms.component";
import { ContentComponent } from "./layouts/content/content.component";
import { HeaderComponent } from "./layouts/header/header.component";
import { FooterComponent } from "./layouts/footer/footer.component";
import { MatDividerModule } from "@angular/material/divider";
import { MatStepperModule } from "@angular/material/stepper";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { UploadFilesComponent } from './stepper-forms/upload-files/upload-files.component';
import { DesignViewComponent } from './stepper-forms/design-view/design-view.component';
import { SpecificationsComponent } from './stepper-forms/specifications/specifications.component';
import { BomUploadComponent } from './stepper-forms/bom-upload/bom-upload.component';
import { QuotationAndOrderComponent } from './stepper-forms/quotation-and-order/quotation-and-order.component';
import { MatListModule } from '@angular/material/list';
import { QuoteMyProjectComponent } from './quote-my-project/quote-my-project.component';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion'; // Import MatExpansionModule
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { WarningComponent } from './warning/warning.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { NgOtpInputModule } from 'ng-otp-input';
import { MatMenuModule } from '@angular/material/menu';
import {MatSliderModule} from '@angular/material/slider';
import {MatTooltipModule} from '@angular/material/tooltip';

import {
  NgxUiLoaderModule,
  NgxUiLoaderConfig,
} from "ngx-ui-loader";
import { EQuotationComponent } from './e-quotation/e-quotation.component';
import { ServiceReqComponent } from './e-quotation/service-req/service-req.component';
import { ProjectDocsComponent } from './e-quotation/project-docs/project-docs.component';
import { ViewEQuoteComponent } from './e-quotation/view-e-quote/view-e-quote.component';
import { SharedModule } from "src/app/shared/shared.module";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";

const ngxUiLoaderConfig: NgxUiLoaderConfig =
{
  "blur": 2,
  "delay": 4,
  "fastFadeOut": true,
  "fgsColor": "#6699FF",
  "fgsPosition": "center-center",
  "fgsSize": 50,
  "fgsType": "wandering-cubes",
  "gap": 24,
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "rgba(237,248,255,0.8)",
  hasProgressBar: false,
}


@NgModule({
  declarations: [
    CreateProjectComponent,
    StepperFormsComponent,
    ContentComponent,
    HeaderComponent,
    FooterComponent,
    UploadFilesComponent,
    DesignViewComponent,
    SpecificationsComponent,
    BomUploadComponent,
    QuotationAndOrderComponent,
    QuoteMyProjectComponent,
    WarningComponent,
    EQuotationComponent,
    ServiceReqComponent,
    ProjectDocsComponent,
    ViewEQuoteComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    QuotingToolRoutingModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatStepperModule,
    ReactiveFormsModule, FormsModule,
    MatProgressBarModule,
    MatTabsModule,
    MatListModule,
    MatTableModule,
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    NgxIntlTelInputModule,
    NgOtpInputModule,
    MatMenuModule,
    MatSliderModule,
    MatTooltipModule,
    MatSelectModule,
    MatPaginatorModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig)
  ],
})
export class QuotingToolModule { }
